export function isNotUndefined<T>(input: T | undefined | null | void): input is T {
  return typeof input !== 'undefined' && input !== null
}
